var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSitePin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 34,
    viewBox: "0 0 27 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_61_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12.5272C24 17.3193 17.6016 25.8508 14.7961 29.3708C14.1234 30.2097 12.8766 30.2097 12.2039 29.3708C9.39844 25.8508 3 17.3193 3 12.5272C3 6.71533 7.70312 2 13.5 2C19.2969 2 24 6.71533 24 12.5272Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 12.5272C24 17.3193 17.6016 25.8508 14.7961 29.3708C14.1234 30.2097 12.8766 30.2097 12.2039 29.3708C9.39844 25.8508 3 17.3193 3 12.5272C3 6.71533 7.70312 2 13.5 2C19.2969 2 24 6.71533 24 12.5272Z",
    stroke: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 21C15.7543 21 17.9163 20.1045 19.5104 18.5104C21.1045 16.9163 22 14.7543 22 12.5C22 10.2457 21.1045 8.08365 19.5104 6.48959C17.9163 4.89553 15.7543 4 13.5 4C11.2457 4 9.08365 4.89553 7.48959 6.48959C5.89553 8.08365 5 10.2457 5 12.5C5 14.7543 5.89553 16.9163 7.48959 18.5104C9.08365 20.1045 11.2457 21 13.5 21ZM13.5 9.3125C14.3454 9.3125 15.1561 9.64833 15.7539 10.2461C16.3517 10.8439 16.6875 11.6546 16.6875 12.5C16.6875 13.3454 16.3517 14.1561 15.7539 14.7539C15.1561 15.3517 14.3454 15.6875 13.5 15.6875C12.6546 15.6875 11.8439 15.3517 11.2461 14.7539C10.6483 14.1561 10.3125 13.3454 10.3125 12.5C10.3125 11.6546 10.6483 10.8439 11.2461 10.2461C11.8439 9.64833 12.6546 9.3125 13.5 9.3125Z",
    fill: "#002C4B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_61_5",
    x: 0,
    y: 0,
    width: 27,
    height: 34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_61_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_61_5",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSitePin);
export default __webpack_public_path__ + "static/media/site-pin.fb4d003d6fb96b471ce1e211de0dfa60.svg";
export { ForwardRef as ReactComponent };